/** Tamanho de página das tabelas de lista (Atendimento HUB, Ocorrências) —
 * o mesmo da fila de Solicitações (`SolicitationTable.ITEMS_PER_PAGE`). */
export const TABLE_PAGE_SIZE = 12

/** Janela de até 5 números de página, deslizando ao redor da atual. */
function getPageNumbers(current: number, total: number): number[] {
  if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1)
  let start = Math.max(1, current - 2)
  const end = Math.min(total, start + 4)
  start = Math.max(1, end - 4)
  return Array.from({ length: end - start + 1 }, (_, i) => start + i)
}

interface TablePaginationProps {
  page: number
  pageSize: number
  total: number
  onPageChange: (page: number) => void
  /** Plural do que está sendo listado — "problemas", "processos"… */
  itemLabel: string
}

/** Rodapé "Mostrando X a Y de Z" + Anterior/números/Próximo. Some com uma
 * página só. */
export function TablePagination({
  page,
  pageSize,
  total,
  onPageChange,
  itemLabel,
}: TablePaginationProps) {
  const totalPages = Math.ceil(total / pageSize)
  if (totalPages <= 1) return null
  const start = (page - 1) * pageSize

  return (
    <div className="flex items-center justify-between border-t border-border-subtle px-4 py-3">
      <div className="text-xs text-body/80">
        Mostrando {start + 1} a {Math.min(start + pageSize, total)} de {total}{' '}
        {itemLabel}
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(page - 1, 1))}
          disabled={page === 1}
          className="rounded-[5px] border border-border-subtle px-3 py-1 text-xs hover:bg-surface-muted disabled:cursor-not-allowed disabled:opacity-50"
        >
          Anterior
        </button>
        <div className="flex items-center gap-1">
          {getPageNumbers(page, totalPages).map((n) => (
            <button
              key={n}
              type="button"
              onClick={() => onPageChange(n)}
              className={`rounded-[5px] border px-3 py-1 text-xs ${
                page === n
                  ? 'border-blue-500 bg-[#2563eb] text-white'
                  : 'border-border-subtle hover:bg-surface-muted'
              }`}
            >
              {n}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={() => onPageChange(Math.min(page + 1, totalPages))}
          disabled={page === totalPages}
          className="rounded-[5px] border border-border-subtle px-3 py-1 text-xs hover:bg-surface-muted disabled:cursor-not-allowed disabled:opacity-50"
        >
          Próximo
        </button>
      </div>
    </div>
  )
}
